import { createEntityContext } from "./createEntityContext";

export const { EntityContext: SectorContext, EntityProvider: SectorProvider } =
  createEntityContext("sectors", "/api/sectors");
